import $ from 'jquery';

//== Barba ==//
import Barba from 'barba.js';
//== Transitions ==//
import transEffect from './transitions/fade.js';
import lazyload from '../modules/lazyload.js';
//== Views ==//
import defaultView from './views/default-view.js';
import homeView from './views/home-view.js';
import faqView from './views/faq-view.js';
import aboutView from './views/about-view.js';
import contactView from './views/contact-view.js';
import mobileLinks from './views/link-view.js';

//== Function ==//
var barba = function() {

  transEffect;

  Barba.Pjax.getTransition = function () {

    return transEffect;
  };

  defaultView();
  homeView();
  faqView();
  aboutView();
  contactView();
  mobileLinks();
  lazyload();

  Barba.Pjax.start();
}

module.exports = barba;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/barba-init.js